import { useSyncExternalStore } from 'react';

import { codesVersion, subscribe } from '../utils/recordCodes';

/**
 * A number that changes whenever the short-URL dictionary (utils/recordCodes)
 * learns a code. A value built from the dictionary — a share URL, a QR code —
 * lists it among its memo's inputs, so it turns short the moment the record's
 * code arrives rather than staying the long form it was first built as.
 */
export default function useRecordCodesVersion() {
	return useSyncExternalStore(subscribe, codesVersion, codesVersion);
}
